function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.505 35.367l-4.122 3.296c2.795 4.444 1.992 7.89 4.4 12.02 2.409 4.13 8.322 4.257 10.967.931 2.646-3.325 1.6-7.685-1.956-10.12-3.555-2.433-5.833-2.86-9.29-6.127zm5.405 7.486c3.32-.147 5.848 4.231 3.641 6.915-2.126 2.73-6.772 1.067-7.328-2.176-.625-2.374 1.245-4.824 3.687-4.739zM24.494 31.496c-.665-.485-1.391-1.035-1.927-1.397-4.763-8.248-9.648-16.432-14.302-24.74A3.316 3.316 0 018 4.267c.06-1.117 1.67-2.774 1.67-2.774S20.255 15.328 28.52 26.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.485 31.414c1.234 1.634 2.362 3.134 3.33 4.427-.847.741-1.693 1.373-2.54 2.114-1.242-.838-2.911-2.086-4.633-3.384"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.168 4.266c-.06-1.117-1.67-2.774-1.67-2.774S29.063 25.384 21.243 35.84c.846.741 1.804 1.373 2.65 2.114 2.83-1.911 7.878-5.945 10.709-7.856 4.762-8.249 9.648-16.432 14.302-24.74.142-.347.246-.716.265-1.093z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.017 30.986c0 .242-.195.439-.436.439s-.435-.197-.435-.439.195-.439.435-.439.436.197.436.439zM20.629 35.367l4.122 3.296c-2.795 4.444-1.992 7.89-4.4 12.02s-8.322 4.257-10.967.931c-2.646-3.325-1.6-7.685 1.956-10.12 3.555-2.433 5.833-2.86 9.29-6.127zm-5.405 7.486c-3.32-.147-5.848 4.231-3.641 6.915 2.126 2.73 6.772 1.067 7.328-2.176.625-2.374-1.245-4.824-3.687-4.739z"
}));

var SvgScissors = function SvgScissors(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScissors, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Scissors.6c71f487.svg";
export { ForwardRef as ReactComponent };